import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  required,
} from 'react-admin';

export const AttributeEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="slug" fullWidth helperText="Автоматически генерируется из названия, если не указан" />
      <TextInput source="description" multiline rows={3} fullWidth />
      
      <ReferenceInput source="groupId" reference="attribute-groups">
        <SelectInput optionText="name" validate={[required()]} />
      </ReferenceInput>
      
      <NumberInput source="sortOrder" />
    </SimpleForm>
  </Edit>
);
